import {SnackbarContent, SnackbarProps} from '../models/snackbar';

export class SnackbarService {

    showSuccess(content: SnackbarContent, timeout: number = 3000): HTMLNjSnackbarElement {
        return this.showSnackbar(content, {type: 'success'}, timeout);
    }

    showError(content: SnackbarContent): HTMLNjSnackbarElement {
        return this.showSnackbar(content, {type: 'error', closeable: true});
    }

    showSnackbar(content: SnackbarContent, props?: SnackbarProps, timeout?: number): HTMLNjSnackbarElement {
        const snackbar = this.createSnackbar(content, props);

        document.body.append(snackbar);

        if (timeout) {
            setTimeout(() => snackbar.remove(), timeout);
        }

        return snackbar;
    }

    createSnackbar(content: SnackbarContent, props?: SnackbarProps): HTMLNjSnackbarElement {
        const snackbar = document.createElement('nj-snackbar');

        snackbar.append(content);

        if (props) {
            Object.entries(props).forEach(([prop, value]) => snackbar.setAttribute(prop, value));
        }

        return snackbar;
    }
}
